<template>
    <div>
        <div v-if="parent" class="lc-reply reply reply-box">
            <strong class="reply__author">{{ parent.author.display_name }}</strong>
            <span class="reply__text" v-html="parent.brief" />
            <attachment v-if="parent.attachment" :attachment="parent.attachment" :is-reply="true" />
            <a href="#" class="icon-button icon-button--large reply__cancel" @click="cancelReply">
                <icon type="close" color="dark" />
            </a>
        </div>

        <div class="lc-comment-box comments__box">
            <div @click.stop class="comments__input">
                <editor placeholder="Your message"
                        @cmd-enter="submit"
                        @emoji-picked="closeEmojis"
                        @text-change="startTyping"
                        :emojis="true"
                        emoji-container=".comments__footer"
                        ref="editor"
                        theme="bubble"
                        :toolbar="toolbar"
                        id="description"
                        class="lc-comment-input"
                        v-model="message"
                        name="description"
                />
            </div>

            <aside class="comments__actions">
                <a @click.prevent="submit" href="#" class="lc-comment-submit button button--icon button--outline comments__button">
                    <img src="/images/send.svg" alt="Send">
                    <span>Send</span>
                </a>
                <div class="comments__action">
                    <a href="#" @click.prevent.stop="$refs.uploader.openFileBrowser()" class="icon-button icon-button--large">
                        <icon type="paperclip" color="bluegray" size="18" />
                    </a>
                </div>
                <div v-if="isMobile === false" class="comments__action comments__actions--emoji">
                    <a @click.prevent.stop="openEmojis()" href="#" class="icon-button icon-button--large">
                        <icon type="smiled" color="bluegray" size="18" />
                    </a>
                </div>
            </aside>

            <emoji-picker v-if="isMobile === false" @select="addEmoji" ref="emojiPicker" />

        </div>

        <div class="comments__uploads" :class="{ 'comments__uploads--active' : showUploads }">
            <div v-if="hasUploads" class="uploads">
                <article class="lc-upload-item upload" v-for="(upload, index) in uploads" :key="index">
                    <p class="upload__title">{{ upload.original_name }}</p>
                    <span class="upload__meta">{{ upload.size | formattedSize }}</span>
                    <span @click.stop="removeAttachment(upload, index)" class="upload__close icon-button icon-button--small">
                        <icon type="close" color="dark" size="14" />
                    </span>
                </article>
            </div>
            <file-uploader ref="uploader" @uploaded="onFileUploaded" @uploading="isUploadingFiles = true" @finished="isUploadingFiles = false" />
        </div>

    </div>
</template>

<script>
/* global Echo, app, _, axios */
import Device from '../../../mixins/deviceAware'
import Form from '../../../helpers/Form'
import { mapState } from 'vuex'
import Attachment from './Attachment'
import EmojiPicker from './EmojiPicker.vue'
import FileUploader from './FileUploader'
import Icon from '../../Global/Icon'
import Editor from '../../Global/Editor'

export default {
    mixins: [Device],

    props: {
        value: {
            type: String
        }
    },

    data () {
        return {
            message: '',
            uploads: [],
            isTyping: false,
            isUploadingFiles: false,
            toolbar: [
                ['bold', 'italic', 'underline', 'strike', 'link'],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }]
            ]
        }
    },

    mounted () {
        if (this.value) {
            this.$refs.input.innerText = this.value
        }
    },

    watch: {
        message (message) {
            this.$emit('input', message)
        },

        value (value) {
            if (value === '') {
                this.$refs.input.innerText = ''
            }
        },

        isTyping (typing) {
            Echo.private(`${app.currentTenant.id}_job_${this.job.id}`)
                .whisper(typing ? 'startTyping' : 'stopTyping', {
                    user: app.currentUser
                })
        }
    },

    methods: {
        showDropzone () {
            this.$refs.uploader.isDraggingFiles = true
        },

        openEmojis () {
            this.$refs.emojiPicker.toggle()
        },

        closeEmojis () {
            this.$refs.emojiPicker.close()
        },

        startTyping () {
            this.isTyping = true

            clearTimeout(this.typingTimer)

            this.typingTimer = setTimeout(() => {
                this.isTyping = false
            }, 1000)
        },

        addEmoji (event) {
            this.$refs.editor.addEmoji(event)
        },

        onFileUploaded (asset) {
            this.uploads.push(asset)
        },

        submit () {
            let form = new Form({
                message: this.message,
                parent: this.parent ? this.parent.id : null,
                attachments: _.map(this.uploads, 'id')
            })

            this.uploads = []
            this.$refs.editor.clear()
            this.isTyping = false
            this.cancelReply()

            this.$store.dispatch('job/addComment', form).then(() => {
                this.$emit('new-comment')
            })
        },

        removeAttachment (upload, index) {
            axios.delete(`/api/job/${this.job.id}/asset/${upload.id}`).then(() => {
                this.uploads.splice(index, 1)
            })
        },

        cancelReply () {
            this.$store.commit('job/REMOVE_PARENT_COMMENT')
        }
    },

    computed: {
        ...mapState('job', {
            job: 'job',
            parent: 'parentComment'
        }),

        hasUploads () {
            return this.uploads.length > 0
        },

        showUploads () {
            if (this.hasUploads || this.isUploadingFiles) {
                return true
            }

            return false
        }
    },

    components: {
        Attachment,
        EmojiPicker,
        FileUploader,
        Icon,
        Editor
    }
}
</script>
